/**
/* See legacy/lp/new-feature-tour/mobile-tour-template-builder.js
/* for event handlers
/* TODO: migrate them to become React event handlers
**/

import React from 'react';

export default function PageActionBar() {
  return (
    <div className='mobile-tour-action'>
      <div className='left-controls'>
        <input id='dont-show' type='checkbox' data-role='seen-mobile-tour-checkbox' />
        <label htmlFor='dont-show'>Don&apos;t show this message again</label>
      </div>
      <div className='right-controls clearfix actions'>
        <a href='#' className='button action blue right continue'><span>Continue</span></a>
        <a href='#' className='button light right back dsbl margin-right'>Back</a>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/ui/alert-dialog/mobile-tour/page-action-bar.jsx